module.exports = __webpack_public_path__ + "static/form-grouping-do-287b62eb24a96c8cb57b2053f27970aa.png";